<template>

	<div v-if="!closed" v-bind:class="{ notificationTooltip : true, buyButton: position && position == 'buyButton', middle: position && position == 'middle' }">
		<span v-html="$t(title)" class="title"> {!  !} </span>
    <span v-html="$t(text)" class="text"> {!  !} </span>
		<div v-on:click="close" class="close"> <i class="icon-close"></i></div>
	</div>

</template>

<script>

export default {
  data: function(){
    return{
      closed: false,
    }
  },

  props: ['identifier', 'title', 'text', 'position', 'showOnce', 'clickHide'],

  methods: {

  	close(){

      var self = this;

  		// Set cookie
  		var Cookies = require('js-cookie');
		  Cookies.set('hide_purchase_now_' + self.identifier, true, { expires: 1, path: '/' });

  		// Close
  		self.closed = true;

  	}

  },


  mounted(){

    var self = this;

  	var Cookies = require('js-cookie');
  	var isHidden = Cookies.get('hide_purchase_now_' + self.identifier);

  	if(typeof isHidden != 'undefined' && isHidden)
  		self.closed = true;

    // Hide of only should show once
    if(typeof self.showOnce != 'undefined' && self.showOnce)
       Cookies.set('hide_purchase_now_' + self.identifier, true, { expires: 1, path: '/' });


     var clicked = false;

    if(typeof self.clickHide != 'undefined' && self.clickHide)
       $(document).on("click", function(){

         if(!clicked)
         {
            clicked = true;
         }
         else{
            self.close();
          }
       })

  }

}

</script>

<style lang="scss">

.notificationTooltip{

	  position: absolute;
    bottom: 19px;
    left: 29px;
    padding: 10px;
    background: rgb(255, 255, 255);
    text-align: center;
    text-shadow: 0 0 black;
    font-size: 14px;
    z-index: 99;

    /* Middle position styles and animations */
    &.middle{
      top: 50%;
      bottom: auto;
      margin-top: -65.5px;
      animation: animatePulseLeft 3s infinite;

       /* Mobile */
      @media screen and (max-width: 844px) {
        top: auto;
        bottom: calc(5px + env(safe-area-inset-bottom));
        left: 14px;
      }
    }

    /* Buy button styles and animations */
    &.buyButton{

      @media screen and (min-width: 1000px) {
        animation: animatePulseLeft 3s infinite;
      }
      /* Tablet */
      @media screen and (max-width: 1024px) {
        bottom: 13px;
        left: 24px;
      }

      /* Mobile */
      @media screen and (max-width: 844px) {
        animation: animatePurchaseNoBottom 3s infinite;
        bottom: calc(35px + env(safe-area-inset-bottom));
        right: 8px;
        left: auto;
      }

    }

    /* Mobile */
    @media screen and (max-width: 844px) {
    	font-size: 12px;
    }

    /* Left sticker */
    &:before{
    	right: 100%;
  		top: 50%;
  		border: solid transparent;
  		content: " ";
  		height: 0;
  		width: 0;
  		position: absolute;
  		pointer-events: none;


	   	border-color: rgba(136, 183, 213, 0);
	    border-right-color: #ffffff;
	    border-width: 12px;
	    margin-top: -12px;

    };

    /* bottom sticker */

    /* Mobile */
    &.buyButton:before{
      @media screen and (max-width: 844px) {
        top: 100%;
        left: calc(50% + 85px);
        right: auto;
        border-width: 16px;
        margin-left: -16px;
        margin-top: 0;
        border-color: rgba(136, 183, 213, 0);
        border-right-color: transparent;
        border-top-color: #ffffff;
    }
      }

    .title{
    	display: block;
	    font-family: "Fanwood+Text";
	    font-style: italic;
	    font-size: 22px;
	    font-weight: 100;
	    margin-bottom: 0px;

	    /* Mobile */
   		@media screen and (max-width: 844px) {
	    	font-size: 15px;
	    	font-weight: bold;
	    }
    }

    .close{
    	position: absolute;
	    right: 0;
	    top: 0;
	    padding: 6px 8px;
	    cursor: pointer;

	    /* Mobile */
   		@media screen and (max-width: 844px) {
	        right: -3px;
		    top: -5px;
		    font-size: 19px;
		}
    }

}

@keyframes animatePulseLeft {
	0%{
        transform: translateX(0px);
    }
    50%{
        transform: translateX(10px);
    }
    100%{
        transform: translateX(0px);
    }
}

@keyframes animatePurchaseNoBottom {
	0%{
        transform: translateY(0px);
    }
    50%{
        transform: translateY(10px);
    }
    100%{
        transform: translateY(0px);
    }
}


</style>



// WEBPACK FOOTER //
// NotificationTooltip.vue?7dd5c5c7